<template>
  <div class="setting-main-container" v-if="getBusinessPermission || userType=='super_admin'">
      <div class="card setting-card">
        <div class="page-header">
          <h3 class="page-title">{{ $t('profile.business_status.business_status') }}</h3>
        </div>
        <div class="row">

          <div class="col-md-6 mb-4">
            <label class="input-label">{{ $tc('profile.business_status.business_status') }}</label><span class="text-danger"> * </span>
            <p v-if="business && business.status !=null ">{{ business.status }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="input-label">{{ $tc('profile.business_status.business_nature') }}</label><span class="text-danger"> * </span>
            <p v-if="business && business.nature !=null ">{{ business.nature }}</p>
          </div>
          <div class="col-md-12 mb-4">
            <label class="input-label">{{ $tc('profile.business_status.annual_sales_turnover') }}</label><span class="text-danger"> * </span>
            <p v-if="business && business.annual_sales_turnover !=null ">{{ business.annual_sales_turnover }}</p>
          </div>
           <div class="col-md-12 mb-4">
            <label class="input-label">{{ $tc('profile.business_status.num_employee_including_contract') }}</label><span class="text-danger"> * </span>
            <p v-if="business && business.total_employees !=null ">{{ business.total_employees }}</p>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { mapActions,mapGetters } from 'vuex'
const { required, email, maxLength, numeric } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data () {
    return {
        isLoading: false,
        userType:null,
    }
  },
  computed: {
    ...mapGetters('business', [
      'business' ,
      'getBusinessPermission',
    ]),

  },
  created() {
    if(localStorage.getItem('role')=='super_admin'){
      this.userType='super_admin';
    }
    if(localStorage.getItem('role')=='super_admin' && this.business==null){
      this.getBusinessData();
    }
    this.checkBusinessPermission();
  },
  validations: {},
  mounted () {},
  methods: {
     ...mapActions('business', [
      'BusinessPermission',
      'falseBusinessPermission',
      'fetchBusinessByUser'
    ]),
    async checkBusinessPermission(){
        await this.BusinessPermission(this.$route.params.id)
    },
    async getBusinessData(){
      let formData = {
          user_id : this.$route.params.id,
      }
       let  response = await this.fetchBusinessByUser(formData)
    }
  }
}
</script>
